import {PostOdontoRebook} from 'domain/usecases';
import {RemotePostOndotRebook} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostOdontoRebook = (): PostOdontoRebook =>
	new RemotePostOndotRebook(
		makeBFFApiUrl(BookedFlowEndPoints.odontoRebooking),
		makeAuthorizeHttpClientDecorator(),
	);
